var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.getFlagBookingOutwardFlightSelected === true ||
    _vm.getFlagBookingReturnFlightSelected === true
      ? _c(
          "div",
          { staticClass: "booking-details sdr-box" },
          [
            _c("h4", [
              _vm._v(_vm._s(_vm.bookingdetails[_vm.getCurrentLocale])),
            ]),
            _vm._v(" "),
            _vm.getFlagBookingOutwardFlightSelected === true
              ? _c("div", [
                  _c("article", { staticClass: "flight-booking-details" }, [
                    _c("div", { staticClass: "details" }, [
                      _c(
                        "div",
                        { staticClass: "constant-column-3 timing clearfix" },
                        [
                          _c("div", { staticClass: "check-in" }, [
                            _c("label", [
                              _vm._v(_vm._s(_vm.takeoff[_vm.getCurrentLocale])),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("dateFlightCart")(
                                    _vm.getBookingCart[0].outward.depDT
                                  )
                                )
                              ),
                              _c("br"),
                              _vm._v(
                                _vm._s(
                                  _vm._f("momentTime")(
                                    _vm.getBookingCart[0].outward.depDT
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "duration text-center" }, [
                            _c("i", { staticClass: "soap-icon-clock" }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("durationFlightCart")(
                                    _vm.getBookingCart[0].outward.dur
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "check-out" }, [
                            _c("label", [
                              _vm._v(_vm._s(_vm.landing[_vm.getCurrentLocale])),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("dateFlightCart")(
                                    _vm.getBookingCart[0].outward.desDT
                                  )
                                )
                              ),
                              _c("br"),
                              _vm._v(
                                _vm._s(
                                  _vm._f("momentTime")(
                                    _vm.getBookingCart[0].outward.desDT
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "article",
                    {
                      staticClass: "detailed-logo",
                      staticStyle: { padding: "0px" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "details" },
                        [
                          _c("center", [
                            _c("h2", { staticClass: "box-title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.getBookingDepArprtCode +
                                    " - " +
                                    _vm.getBookingDesArprtCode
                                )
                              ),
                              _c("small", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getBookingDepArprtName +
                                      " - " +
                                      _vm.getBookingDesArprtName
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.getBookingCart, function (pax, index) {
                            return _c(
                              "div",
                              { key: index },
                              [
                                _c("h4", { staticClass: "paxheadline" }, [
                                  _vm._v(
                                    _vm._s(_vm.trnslPaxTypes(pax.type)) +
                                      " " +
                                      _vm._s(pax.counter)
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.modulo === "booking"
                                  ? _c(
                                      "span",
                                      { staticClass: "price clearfix" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "collapsed",
                                            attrs: {
                                              "data-toggle": "collapse",
                                              href:
                                                "#pax-tax-panel-outward" +
                                                pax.id,
                                            },
                                          },
                                          [
                                            _c(
                                              "small",
                                              { staticClass: "pull-left" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.flightprice[
                                                      _vm.getCurrentLocale
                                                    ]
                                                  ) + " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "tooltip",
                                                    rawName: "v-tooltip",
                                                    value:
                                                      _vm.seetaxes[
                                                        _vm.getCurrentLocale
                                                      ],
                                                    expression:
                                                      "seetaxes[getCurrentLocale]",
                                                  },
                                                ],
                                                staticClass: "pull-right",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("rndAmntRUAFWZ")(
                                                      pax.outward.totalprice !==
                                                        undefined
                                                        ? pax.outward.totalprice
                                                        : "0"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.modulo === "services"
                                  ? _c(
                                      "span",
                                      { staticClass: "price clearfix" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "collapsed",
                                            attrs: {
                                              "data-toggle": "collapse",
                                              href:
                                                "#pax-tax-panel-outward" +
                                                pax.id,
                                            },
                                          },
                                          [
                                            _c(
                                              "small",
                                              { staticClass: "pull-left" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.flightpricesrvcs[
                                                      _vm.getCurrentLocale
                                                    ]
                                                  ) + " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "pull-right" },
                                              [_vm._v("-")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.modulo === "booking"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "panel-collapse collapse",
                                        attrs: {
                                          id: "pax-tax-panel-outward" + pax.id,
                                        },
                                      },
                                      [
                                        _c(
                                          "dl",
                                          { staticClass: "other-details" },
                                          [
                                            _c(
                                              "dt",
                                              { staticClass: "feature" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.airfare[
                                                      _vm.getCurrentLocale
                                                    ]
                                                  ) + ":"
                                                ),
                                              ]
                                            ),
                                            _c("dd", { staticClass: "value" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("rndAmntRUAFWZ")(
                                                    pax.outward.price !==
                                                      undefined
                                                      ? pax.outward.price
                                                      : "0"
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "dt",
                                              { staticClass: "feature" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.airporttaxes[
                                                      _vm.getCurrentLocale
                                                    ]
                                                  ) + ":"
                                                ),
                                              ]
                                            ),
                                            _c("dd", { staticClass: "value" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("rndAmntRUAFWZ")(
                                                    pax.outward.taxes !==
                                                      undefined
                                                      ? pax.outward.taxes.air
                                                      : "0"
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "dt",
                                              { staticClass: "feature" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.aviationtax[
                                                      _vm.getCurrentLocale
                                                    ]
                                                  ) + ":"
                                                ),
                                              ]
                                            ),
                                            _c("dd", { staticClass: "value" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("rndAmntRUAFWZ")(
                                                    pax.outward.taxes !==
                                                      undefined
                                                      ? pax.outward.taxes.avia
                                                      : "0"
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "dt",
                                              { staticClass: "feature" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.kerosenesurcharge[
                                                      _vm.getCurrentLocale
                                                    ]
                                                  ) + ":"
                                                ),
                                              ]
                                            ),
                                            _c("dd", { staticClass: "value" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("rndAmntRUAFWZ")(
                                                    pax.outward.taxes !==
                                                      undefined
                                                      ? pax.outward.taxes.fuel
                                                      : "0"
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "dt",
                                              { staticClass: "feature" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.securitycharges[
                                                      _vm.getCurrentLocale
                                                    ]
                                                  ) + ":"
                                                ),
                                              ]
                                            ),
                                            _c("dd", { staticClass: "value" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("rndAmntRUAFWZ")(
                                                    pax.outward.taxes !==
                                                      undefined
                                                      ? pax.outward.taxes.sec
                                                      : "0"
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "dt",
                                              { staticClass: "feature" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.servicecharges[
                                                      _vm.getCurrentLocale
                                                    ]
                                                  ) + ":"
                                                ),
                                              ]
                                            ),
                                            _c("dd", { staticClass: "value" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("rndAmntRUAFWZ")(
                                                    pax.outward.taxes !==
                                                      undefined
                                                      ? pax.outward.taxes.srvc
                                                      : "0"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                pax.outward_seat.seatno !== undefined
                                  ? _c(
                                      "span",
                                      { staticClass: "price clearfix" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            ref:
                                              "pax-delete-seat-outward-" +
                                              pax.id_pax +
                                              "-" +
                                              pax.outward_seat.seatno,
                                            refInFor: true,
                                            staticClass: "collapsed",
                                            attrs: {
                                              "data-toggle": "collapse",
                                              href:
                                                "#pax-delete-seat-outward-" +
                                                pax.id_pax +
                                                "-" +
                                                pax.outward_seat.seatno,
                                            },
                                          },
                                          [
                                            _c(
                                              "small",
                                              { staticClass: "pull-left" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.seat[
                                                      _vm.getCurrentLocale
                                                    ]
                                                  ) + ": "
                                                ),
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("truncate")(
                                                        pax.outward_seat.seatno,
                                                        17,
                                                        "..."
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "soap-icon-triangle-bottom yellow-color",
                                            }),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "tooltip",
                                                    rawName: "v-tooltip",
                                                    value:
                                                      _vm.wannedeleteseat[
                                                        _vm.getCurrentLocale
                                                      ],
                                                    expression:
                                                      "wannedeleteseat[getCurrentLocale]",
                                                  },
                                                ],
                                                staticClass: "pull-right",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("rndAmntRUAFWZ")(
                                                      pax.outward_seat.price !==
                                                        undefined
                                                        ? parseFloat(
                                                            pax.outward_seat
                                                              .price
                                                          )
                                                        : "0"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                pax.outward_seat.seatno !== undefined
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "panel-collapse collapse",
                                        attrs: {
                                          id:
                                            "pax-delete-seat-outward-" +
                                            pax.id_pax +
                                            "-" +
                                            pax.outward_seat.seatno,
                                        },
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "button btn-small sundair pull-right",
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                _vm.onClick_DeleteSeat({
                                                  id_pax: pax.id_pax,
                                                  type: "outward",
                                                  seat: pax.outward_seat,
                                                })
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.wannedeleteseat[
                                                  _vm.getCurrentLocale
                                                ]
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("br"),
                                        _c("br"),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(
                                  pax.outward_srvcs,
                                  function (srvcs, index2) {
                                    return _c("span", { key: index2 }, [
                                      _c(
                                        "span",
                                        { staticClass: "price clearfix" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              ref:
                                                "pax-delete-service-outward-" +
                                                pax.id_pax +
                                                "-" +
                                                srvcs.id,
                                              refInFor: true,
                                              staticClass: "collapsed",
                                              attrs: {
                                                "data-toggle": "collapse",
                                                href:
                                                  "#pax-delete-service-outward-" +
                                                  pax.id_pax +
                                                  "-" +
                                                  srvcs.id,
                                              },
                                            },
                                            [
                                              _c(
                                                "small",
                                                {
                                                  directives: [
                                                    {
                                                      name: "tooltip",
                                                      rawName: "v-tooltip",
                                                      value: srvcs.description,
                                                      expression:
                                                        "srvcs.description",
                                                    },
                                                  ],
                                                  staticClass: "pull-left",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("truncate")(
                                                        srvcs.description,
                                                        17,
                                                        "..."
                                                      )
                                                    ) + " "
                                                  ),
                                                ]
                                              ),
                                              _c("i", {
                                                staticClass:
                                                  "soap-icon-triangle-bottom yellow-color",
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "tooltip",
                                                      rawName: "v-tooltip",
                                                      value:
                                                        _vm.wannedelete[
                                                          _vm.getCurrentLocale
                                                        ],
                                                      expression:
                                                        "wannedelete[getCurrentLocale]",
                                                    },
                                                  ],
                                                  staticClass: "pull-right",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("rndAmntRUAFWZ")(
                                                        srvcs.price !==
                                                          undefined
                                                          ? parseFloat(
                                                              srvcs.price
                                                            ) *
                                                              parseFloat(
                                                                srvcs.userInputSrvcsDetails_Count
                                                              )
                                                          : "0"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "panel-collapse collapse",
                                          attrs: {
                                            id:
                                              "pax-delete-service-outward-" +
                                              pax.id_pax +
                                              "-" +
                                              srvcs.id,
                                          },
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "button btn-small sundair pull-right",
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  _vm.onClick_DeleteSrvcs({
                                                    id_pax: pax.id_pax,
                                                    srvcs: srvcs,
                                                    type: "outward",
                                                  })
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.deletesrvcs[
                                                    _vm.getCurrentLocale
                                                  ]
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("br"),
                                          _c("br"),
                                        ]
                                      ),
                                    ])
                                  }
                                ),
                              ],
                              2
                            )
                          }),
                          _vm._v(" "),
                          _c("dl", { staticClass: "other-details" }, [
                            _c("dt", { staticClass: "total-price" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.totaloutwardprice[_vm.getCurrentLocale]
                                ) + ":"
                              ),
                            ]),
                            _c("dd", { staticClass: "total-price-value" }, [
                              _vm._v("-"),
                            ]),
                          ]),
                        ],
                        2
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.getBookingUsersSearchData.rTrip === true &&
            _vm.getFlagBookingReturnFlightSelected === true
              ? _c("div", [
                  _c("br"),
                  _vm._v(" "),
                  _c("article", { staticClass: "flight-booking-details" }, [
                    _c("div", { staticClass: "details" }, [
                      _c(
                        "div",
                        { staticClass: "constant-column-3 timing clearfix" },
                        [
                          _c("div", { staticClass: "check-in" }, [
                            _c("label", [
                              _vm._v(_vm._s(_vm.takeoff[_vm.getCurrentLocale])),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("dateFlightCart")(
                                    _vm.getBookingCart[0].return.depDT
                                  )
                                )
                              ),
                              _c("br"),
                              _vm._v(
                                _vm._s(
                                  _vm._f("momentTime")(
                                    _vm.getBookingCart[0].return.depDT
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "duration text-center" }, [
                            _c("i", { staticClass: "soap-icon-clock" }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("durationFlightCart")(
                                    _vm.getBookingCart[0].return.dur
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "check-out" }, [
                            _c("label", [
                              _vm._v(_vm._s(_vm.landing[_vm.getCurrentLocale])),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("dateFlightCart")(
                                    _vm.getBookingCart[0].return.desDT
                                  )
                                )
                              ),
                              _c("br"),
                              _vm._v(
                                _vm._s(
                                  _vm._f("momentTime")(
                                    _vm.getBookingCart[0].return.desDT
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "article",
                    {
                      staticClass: "detailed-logo",
                      staticStyle: { padding: "0px" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "details" },
                        [
                          _vm.getBookingDesArprtCodeReturnToOther === null
                            ? _c("center", [
                                _c("h2", { staticClass: "box-title" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getBookingDesArprtCode +
                                        " - " +
                                        _vm.getBookingDepArprtCode
                                    )
                                  ),
                                  _c("small", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getBookingDesArprtName +
                                          " - " +
                                          _vm.getBookingDepArprtName
                                      )
                                    ),
                                  ]),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.getBookingDesArprtCodeReturnToOther !== null
                            ? _c("center", [
                                _c("h2", { staticClass: "box-title" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getBookingDepArprtCodeReturnToOther +
                                        " - " +
                                        _vm.getBookingDesArprtCodeReturnToOther
                                    )
                                  ),
                                  _c("small", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getBookingDepArprtNameReturnToOther +
                                          " - " +
                                          _vm.getBookingDesArprtNameReturnToOther
                                      )
                                    ),
                                  ]),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.getBookingCart, function (pax, index) {
                            return _c(
                              "div",
                              { key: index },
                              [
                                _c("h4", { staticClass: "paxheadline" }, [
                                  _vm._v(
                                    _vm._s(_vm.trnslPaxTypes(pax.type)) +
                                      " " +
                                      _vm._s(pax.counter)
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.modulo === "booking"
                                  ? _c(
                                      "span",
                                      { staticClass: "price clearfix" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "collapsed",
                                            attrs: {
                                              "data-toggle": "collapse",
                                              href:
                                                "#pax-tax-panel-return" +
                                                pax.id,
                                            },
                                          },
                                          [
                                            _c(
                                              "small",
                                              { staticClass: "pull-left" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.flightprice[
                                                      _vm.getCurrentLocale
                                                    ]
                                                  ) + " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "tooltip",
                                                    rawName: "v-tooltip",
                                                    value:
                                                      _vm.seetaxes[
                                                        _vm.getCurrentLocale
                                                      ],
                                                    expression:
                                                      "seetaxes[getCurrentLocale]",
                                                  },
                                                ],
                                                staticClass: "pull-right",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("rndAmntRUAFWZ")(
                                                      pax.return.totalprice !==
                                                        undefined
                                                        ? pax.return.totalprice
                                                        : "0"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.modulo === "services"
                                  ? _c(
                                      "span",
                                      { staticClass: "price clearfix" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "collapsed",
                                            attrs: {
                                              "data-toggle": "collapse",
                                              href:
                                                "#pax-tax-panel-return" +
                                                pax.id,
                                            },
                                          },
                                          [
                                            _c(
                                              "small",
                                              { staticClass: "pull-left" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.flightpricesrvcs[
                                                      _vm.getCurrentLocale
                                                    ]
                                                  ) + " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "pull-right" },
                                              [_vm._v("-")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.modulo === "booking"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "panel-collapse collapse",
                                        attrs: {
                                          id: "pax-tax-panel-return" + pax.id,
                                        },
                                      },
                                      [
                                        _c(
                                          "dl",
                                          { staticClass: "other-details" },
                                          [
                                            _c(
                                              "dt",
                                              { staticClass: "feature" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.airfare[
                                                      _vm.getCurrentLocale
                                                    ]
                                                  ) + ":"
                                                ),
                                              ]
                                            ),
                                            _c("dd", { staticClass: "value" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("rndAmntRUAFWZ")(
                                                    pax.return.price !==
                                                      undefined
                                                      ? pax.return.price
                                                      : "0"
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "dt",
                                              { staticClass: "feature" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.airporttaxes[
                                                      _vm.getCurrentLocale
                                                    ]
                                                  ) + ":"
                                                ),
                                              ]
                                            ),
                                            _c("dd", { staticClass: "value" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("rndAmntRUAFWZ")(
                                                    pax.return.taxes !==
                                                      undefined
                                                      ? pax.return.taxes.air
                                                      : "0"
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "dt",
                                              { staticClass: "feature" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.aviationtax[
                                                      _vm.getCurrentLocale
                                                    ]
                                                  ) + ":"
                                                ),
                                              ]
                                            ),
                                            _c("dd", { staticClass: "value" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("rndAmntRUAFWZ")(
                                                    pax.return.taxes !==
                                                      undefined
                                                      ? pax.return.taxes.avia
                                                      : "0"
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "dt",
                                              { staticClass: "feature" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.kerosenesurcharge[
                                                      _vm.getCurrentLocale
                                                    ]
                                                  ) + ":"
                                                ),
                                              ]
                                            ),
                                            _c("dd", { staticClass: "value" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("rndAmntRUAFWZ")(
                                                    pax.return.taxes !==
                                                      undefined
                                                      ? pax.return.taxes.fuel
                                                      : "0"
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "dt",
                                              { staticClass: "feature" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.securitycharges[
                                                      _vm.getCurrentLocale
                                                    ]
                                                  ) + ":"
                                                ),
                                              ]
                                            ),
                                            _c("dd", { staticClass: "value" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("rndAmntRUAFWZ")(
                                                    pax.return.taxes !==
                                                      undefined
                                                      ? pax.return.taxes.sec
                                                      : "0"
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "dt",
                                              { staticClass: "feature" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.servicecharges[
                                                      _vm.getCurrentLocale
                                                    ]
                                                  ) + ":"
                                                ),
                                              ]
                                            ),
                                            _c("dd", { staticClass: "value" }, [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("rndAmntRUAFWZ")(
                                                    pax.return.taxes !==
                                                      undefined
                                                      ? pax.return.taxes.srvc
                                                      : "0"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                pax.return_seat.seatno !== undefined
                                  ? _c(
                                      "span",
                                      { staticClass: "price clearfix" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            ref:
                                              "pax-delete-seat-return-" +
                                              pax.id_pax +
                                              "-" +
                                              pax.return_seat.seatno,
                                            refInFor: true,
                                            staticClass: "collapsed",
                                            attrs: {
                                              "data-toggle": "collapse",
                                              href:
                                                "#pax-delete-seat-return-" +
                                                pax.id_pax +
                                                "-" +
                                                pax.return_seat.seatno,
                                            },
                                          },
                                          [
                                            _c(
                                              "small",
                                              { staticClass: "pull-left" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.seat[
                                                      _vm.getCurrentLocale
                                                    ]
                                                  ) + ": "
                                                ),
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("truncate")(
                                                        pax.return_seat.seatno,
                                                        17,
                                                        "..."
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "soap-icon-triangle-bottom yellow-color",
                                            }),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "tooltip",
                                                    rawName: "v-tooltip",
                                                    value:
                                                      _vm.wannedeleteseat[
                                                        _vm.getCurrentLocale
                                                      ],
                                                    expression:
                                                      "wannedeleteseat[getCurrentLocale]",
                                                  },
                                                ],
                                                staticClass: "pull-right",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("rndAmntRUAFWZ")(
                                                      pax.return_seat.price !==
                                                        undefined
                                                        ? parseFloat(
                                                            pax.return_seat
                                                              .price
                                                          )
                                                        : "0"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                pax.return_seat.seatno !== undefined
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "panel-collapse collapse",
                                        attrs: {
                                          id:
                                            "pax-delete-seat-return-" +
                                            pax.id_pax +
                                            "-" +
                                            pax.return_seat.seatno,
                                        },
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "button btn-small sundair pull-right",
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                _vm.onClick_DeleteSeat({
                                                  id_pax: pax.id_pax,
                                                  type: "return",
                                                  seat: pax.return_seat,
                                                })
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.wannedeleteseat[
                                                  _vm.getCurrentLocale
                                                ]
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("br"),
                                        _c("br"),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(
                                  pax.return_srvcs,
                                  function (srvcs, index2) {
                                    return _c("span", { key: index2 }, [
                                      _c(
                                        "span",
                                        { staticClass: "price clearfix" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              ref:
                                                "pax-delete-service-return-" +
                                                pax.id_pax +
                                                "-" +
                                                srvcs.id,
                                              refInFor: true,
                                              staticClass: "collapsed",
                                              attrs: {
                                                "data-toggle": "collapse",
                                                href:
                                                  "#pax-delete-service-return-" +
                                                  pax.id_pax +
                                                  "-" +
                                                  srvcs.id,
                                              },
                                            },
                                            [
                                              _c(
                                                "small",
                                                {
                                                  directives: [
                                                    {
                                                      name: "tooltip",
                                                      rawName: "v-tooltip",
                                                      value: srvcs.description,
                                                      expression:
                                                        "srvcs.description",
                                                    },
                                                  ],
                                                  staticClass: "pull-left",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("truncate")(
                                                        srvcs.description,
                                                        17,
                                                        "..."
                                                      )
                                                    ) + " "
                                                  ),
                                                ]
                                              ),
                                              _c("i", {
                                                staticClass:
                                                  "soap-icon-triangle-bottom yellow-color",
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "tooltip",
                                                      rawName: "v-tooltip",
                                                      value:
                                                        _vm.wannedelete[
                                                          _vm.getCurrentLocale
                                                        ],
                                                      expression:
                                                        "wannedelete[getCurrentLocale]",
                                                    },
                                                  ],
                                                  staticClass: "pull-right",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("rndAmntRUAFWZ")(
                                                        srvcs.price !==
                                                          undefined
                                                          ? parseFloat(
                                                              srvcs.price
                                                            ) *
                                                              parseFloat(
                                                                srvcs.userInputSrvcsDetails_Count
                                                              )
                                                          : "0"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "panel-collapse collapse",
                                          attrs: {
                                            id:
                                              "pax-delete-service-return-" +
                                              pax.id_pax +
                                              "-" +
                                              srvcs.id,
                                          },
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "button btn-small sundair pull-right",
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  _vm.onClick_DeleteSrvcs({
                                                    id_pax: pax.id_pax,
                                                    srvcs: srvcs,
                                                    type: "return",
                                                  })
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.deletesrvcs[
                                                    _vm.getCurrentLocale
                                                  ]
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("br"),
                                          _c("br"),
                                        ]
                                      ),
                                    ])
                                  }
                                ),
                              ],
                              2
                            )
                          }),
                          _vm._v(" "),
                          _c("dl", { staticClass: "other-details" }, [
                            _c("dt", { staticClass: "total-price" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.totalreturnprice[_vm.getCurrentLocale]
                                ) + ":"
                              ),
                            ]),
                            _c("dd", { staticClass: "total-price-value" }, [
                              _vm._v("-"),
                            ]),
                          ]),
                        ],
                        2
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.getFlagBookingOutwardFlightSelected === true ||
            _vm.getFlagBookingReturnFlightSelected === true
              ? _c("div", [
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn-large full-width sundair",
                      class: { sundairsrvcs: _vm.modulo === "services" },
                      staticStyle: {
                        cursor: "initial",
                        outline: "none !important",
                        "outline-style": "none !important",
                      },
                    },
                    [
                      _vm._v("-"),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "font-size": "0.5em" } }, [
                        _vm._v(
                          _vm._s(_vm.tincludedtaxes[_vm.getCurrentLocale])
                        ),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("v-dialog"),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }